

import templateLoginPage from '@/app-template/lib/pages/LoginPage.vue';

export default {
  name: "LoginPage",
  components: { templateLoginPage },
};
